import {
    Directive,
    ElementRef, Input,
    Renderer2,
} from '@angular/core';
import {Util} from "../app/util";
import {CONFIG} from "../app/config";
import {Content} from "ionic-angular";

@Directive({
    selector: '[corback]'
})
export class CorbackDirective {

    config: any;
    private _element: HTMLElement;

    @Input('corback')
    set corcor(data: string) {

        this.dataSetted(data);

    }

    @Input('nostyle') nostyle: boolean;

    @Input('content') content: Content;

    constructor(element: ElementRef, public renderer: Renderer2, public util: Util) {

        this.config = CONFIG;
        this._element = element.nativeElement;

    }

    ngAfterViewInit() {

        if (this.nostyle) return;

        let name = (this._element.tagName.toLowerCase() == 'ion-header' ? 'corcor-header' : 'corcor-color');
        this.renderer.addClass(this._element, name);

    }

    dataSetted(data: string) {

        this._element.style.setProperty('--varBackcolor', this.config.colors[data]);
        this._element.style.setProperty('--varFontcolor', this.config.colors[this.config.negative(data)]);

        if (this.content) this.content.resize();

    }

}



// WEBPACK FOOTER //
// ./src/directives/corback.ts